export const environment = {
  launchDarklyClientId: '64104d40a96aa0128b224e44', // gitleaks:allow
};
